// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"ChatList_loadingWrapper__1hWek"};